import { keyCodes } from '../constants';

const useInteractiveAttributes = (onClick) => {
  const handleKeyDown = (e) => {
    if (e.keyCode === keyCodes.SPACE || e.keyCode === keyCodes.ENTER) {
      e.preventDefault();
      onClick();
    }
  };

  return {
    role: 'button',
    tabIndex: '0',
    onKeyDown: handleKeyDown,
  };
};

export default useInteractiveAttributes;
